<template>
    <Teleport to="body">
        <TeleportModal
            :show="showDialog"
            @close="onCancel"
            data-testid="create-view-modal"
        >
            <template #header>
                <h2>You have unconfirmed changes in Dashboard Administration</h2>
            </template>
            <template #body>
                <div class="modal-content">
                    By leaving this page, changes made in Dashboard Administration will be lost. Are you sure you wish
                    to proceed?
                </div>
            </template>
            <template #footer>
                <div class="submit-buttons">
                    <al-button
                        variant="secondary"
                        @click="onCancel"
                    >
                        <span> No, Don't Leave </span>
                    </al-button>
                    <al-button
                        varian="primary"
                        @click="onOk"
                    >
                        <span class="with-loader"> Yes, Dismiss Changes </span>
                    </al-button>
                </div>
            </template>
        </TeleportModal>
    </Teleport>
</template>

<script setup lang="ts">
import TeleportModal from '@agyletime/vue-3-common/src/components/Modal/TeleportModal.vue';

const showDialog = defineModel<boolean>();

const emit = defineEmits<{ onClose: [boolean] }>();

const onCancel = () => {
    showDialog.value = false;
    emit('onClose', false);
};

const onOk = () => {
    showDialog.value = false;
    emit('onClose', true);
};
</script>

<style scoped lang="scss">
@use '@/styles/commonPageStyles';
@use '@/styles/tabs';

h1 {
    font-size: 1.6rem;
}
</style>